<template>
    <div class="error-msg-wrap">
        <div v-if="loaded" class="form-wrapper slide-up">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
            </div>
            <h3>Name</h3>
            <input type="text" v-model="formData.Name" />
            <h3>Steps</h3>
            <draggable :list="formData.StepsJSON">
                <div v-for="(step, i) in formData.StepsJSON" :key="i" class="link-item">
                    <div class="form-close">
                        <svg @click="removeStep(i)" style="color:red;width:18px;height:18px;" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 16.538l-4.592-4.548 4.546-4.587-1.416-1.403-4.545 4.589-4.588-4.543-1.405 1.405 4.593 4.552-4.547 4.592 1.405 1.405 4.555-4.596 4.591 4.55 1.403-1.416z"/></svg>
                    </div>
                    <input type="text" v-model="step.name" placeholder="Step Name" />
                    <input type="text" v-model="step.link" placeholder="Step Link" @input="checkLink(step)" />
                    <drop-file @fileChange="onFileChange($event, step)" customText="Add PDF or MP4" class="slim-drop-file" />
                    <textarea style="margin: 15px 0 0" v-model="step.agreeText" placeholder="Agreement Text (optional)"></textarea>
                </div>
            </draggable>
            <div style="display:flex">
                <div @click="addStep()" class="btn" style="margin:0">Add Step</div>
            </div>
            <input style="margin-top:25px" :class="disableButton ? 'disable-button' : ''" type="submit" value="Submit" @click="submit()" />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';
import axios from 'axios';
import { VueDraggableNext } from 'vue-draggable-next';
import DropFile from './DropFile.vue';

export default defineComponent({
    name: 'AddEditOnboarding',
    props: [ 'onboardingToEdit' ],
    components: {
        draggable: VueDraggableNext,
        DropFile
    },
    data() {
        return {
            disableButton: false,
            loaded: false,
            formData: {
                Name: '',
                StepsJSON: [] as any
            },
        }
    },
    async created() {
        if(this.onboardingToEdit) {
            this.formData = JSON.parse(JSON.stringify(this.onboardingToEdit));
        }

        this.loaded = true;
    },
    methods: {
        async submit() {
            if(!this.formData.Name) {
                alert('Include a name');
                return;
            }
            if(!this.formData.StepsJSON.length) {
                alert('Include steps');
                return;
            }

            for(const step of this.formData.StepsJSON) {
                if(!step.name) {
                    alert('Include a name for each step, or remove that step');
                    return;
                }
                if(!step.link) {
                    alert('Include a link for each step, or remove that step');
                    return;
                }
                if(!step.link.includes('https://') && !step.link.includes('http://') && step.link.includes('.')) {
                    step.link = 'https://' + step.link;
                }
            }

            this.disableButton = true;

            await axios.post(`${this.$store.state.apiUrl}/api/onboardings`, this.formData)
                .then(resp => {
                    this.$emit('close');
                })
                .catch(e => {
                    alert('There was an error')
                    console.log(e);
                })

            this.disableButton = false;
        },
        addStep() {
            this.formData.StepsJSON.push({
                name: '',
                link: '',
                id: new Date().getTime().toString(36)
            })
        },
        async onFileChange(file: any, step: any) {
            if(file) {
                const fileNameLower = file.name.toLowerCase();
                if(!fileNameLower.includes('.pdf') && !fileNameLower.includes('.mp4')) {
                        alert('File must be a PDF or MP4');
                        return;
                }
                this.disableButton = true;
                const formData = new FormData();
                formData.append('file', file);
                await axios.post(`${this.$store.state.apiUrl}/api/playbook/processimage`, formData)
                    .then(resp => {
                        step.link = this.$store.state.spacesUrl + resp.data.key;
                    })
                    .catch(e => {
                        console.log(e);
                        alert("There was an error.");
                    })
                this.disableButton = false;
            }
        },
        checkLink(step: any) {
            if(step.link) {
                step.link = this.convertVideoEmbedLink(step.link);
            }
        },
        removeStep(i: number) {
            this.formData.StepsJSON.splice(i, 1);
        }
    }
});
</script>
